import React__default from 'react';

const registerEvents = (ref, events) => {
  if (!ref || !events) {
    return [];
  }
  if (!(ref instanceof EventTarget)) {
    return [];
  }
  const registeredEvents = [];
  for (const event in events) {
    if (!event.startsWith("on")) {
      continue;
    }
    const type = event.substring(2).toLowerCase();
    const callback = events[event];
    ref.addEventListener(type, callback);
    registeredEvents.push({
      type,
      callback
    });
  }
  return registeredEvents;
};
const unregisterEvents = (ref, events) => {
  if (!ref || !events) {
    return;
  }
  if (!(ref instanceof EventTarget)) {
    return;
  }
  for (const event of events) {
    ref.removeEventListener(event.type, event.callback);
  }
};
const useFloatingReference = (reference, ref, getReferenceProps) => {
  React__default.useLayoutEffect(() => {
    if (!ref || !reference) {
      return void 0;
    }
    reference(ref);
    if (getReferenceProps !== void 0 && ref instanceof Element) {
      const node = ref;
      const events = registerEvents(node, getReferenceProps());
      return () => unregisterEvents(node, events);
    }
    return void 0;
  }, [reference, ref, getReferenceProps]);
};
const useTriggerElement = (reference, triggerElement, getReferenceProps) => {
  return React__default.useMemo(() => {
    if (!triggerElement) {
      return null;
    }
    return React__default.cloneElement(triggerElement, { ref: reference, ...getReferenceProps() });
  }, [reference, triggerElement, getReferenceProps]);
};

export { registerEvents, unregisterEvents, useFloatingReference, useTriggerElement };
